import { z } from 'zod'

export const paramsSchema = z.object({
  slugs: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
